import { Box } from '@mui/material';
import type { FieldMode } from '../../../hooks/useCaseField';
import { CaseTextField } from '../../fields';
import PayerField from './PayerField';

interface PayerSectionProps {
  mode: FieldMode;
  company?: string;
  centerId?: string;
  errors?: { [key: string]: string | undefined };
}

const PayerSection: React.FC<PayerSectionProps> = ({ mode, company = '', centerId = '', errors = {} }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, mb: 2.5 }}>
    <PayerField mode={mode} company={company} centerId={centerId} error={errors.payer} />
    <CaseTextField mode={mode} label="Payer Name"
      getValue={d => d.payerName} getUpdate={v => ({ payerName: v })} />
  </Box>
);

export default PayerSection;